import React from 'react';

const OldPortalMessage = () => {
  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h1>Old Portal</h1>
      <p>On this URL will load the old portal.</p>
      <p>
        Repository:{' '}
        <a href="https://dev.azure.com/maritimesim/Nemo/_git/Connect.Portal" target="_blank" rel="noopener noreferrer">
          https://dev.azure.com/maritimesim/Nemo/_git/Connect.Portal
        </a>
      </p>
    </div>
  );
};

export default OldPortalMessage;
